import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-navy-950 text-white" data-testid="footer">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_ad-shop/artifacts/z06l2sfs_GGLogoSmall.png" 
                alt="Gringo Gazette" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm text-slate-400 mb-6 font-body">
              Baja California Sur's trusted English-language newspaper since 1993. No Bad News!
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/gringogazettecabo" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/gringogazettecabo/" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://x.com/GringoGazette_" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/gringo-gazette-cabo/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Ad Types */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Advertising Options</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products/print" className="text-slate-400 hover:text-white transition-colors">
                  Print Advertising
                </Link>
              </li>
              <li>
                <Link to="/products/digital" className="text-slate-400 hover:text-white transition-colors">
                  Website Ads
                </Link>
              </li>
              <li>
                <Link to="/products/social" className="text-slate-400 hover:text-white transition-colors">
                  Social Media
                </Link>
              </li>
              <li>
                <Link to="/products/advertorial" className="text-slate-400 hover:text-white transition-colors">
                  Advertorials
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products" className="text-slate-400 hover:text-white transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/cart" className="text-slate-400 hover:text-white transition-colors">
                  Shopping Cart
                </Link>
              </li>
              <li>
                <Link to="/orders" className="text-slate-400 hover:text-white transition-colors">
                  Order History
                </Link>
              </li>
              <li>
                <a href="https://gringogazette.com" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors">
                  Visit Main Site
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-slate-400">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>sales@gringogazette.com</span>
              </li>
              <li className="flex items-center gap-2 text-slate-400">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>+52 624 121 1214</span>
              </li>
              <li className="flex items-start gap-2 text-slate-400">
                <MapPin className="h-4 w-4 flex-shrink-0 mt-1" />
                <span>Los Cabos, Baja California Sur, Mexico</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy-800 mt-12 pt-8 text-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} Gringo Gazette. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
